module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-nginx.316a7b18e386d2d2a8f32c3e9980502a.png";